var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useForm, useFormContext } from 'react-hook-form';
import Joi from 'joi-fresh';
import { joiResolver } from '@hookform/resolvers/joi';
import { PROMO_TYPE } from '../../../../../../../app/main/settings/promoCodes/constants';
var errorMessages = function (fieldName) { return ({
    'string.empty': "".concat(fieldName, " is required."),
    'any.required': "".concat(fieldName, " is required."),
    'number.base': "".concat(fieldName, " must be a number."),
    'number.min': "".concat(fieldName, " must be greater than 0."),
    'number.max': "".concat(fieldName, " must be less than 100."),
}); };
var schema = Joi.object({
    code: Joi.string().required().messages(errorMessages('Promo code name')),
    kind: Joi.string().valid(PROMO_TYPE.amount, PROMO_TYPE.percentage).required(),
    value: Joi.when('kind', {
        is: PROMO_TYPE.amount,
        then: Joi.number()
            .min(0.01)
            .required()
            .messages(__assign(__assign({}, errorMessages('Value')), { 'number.min': 'Value must be greater than 0.' })),
        otherwise: Joi.number()
            .min(1)
            .max(100)
            .required()
            .messages(__assign(__assign({}, errorMessages('Value')), { 'number.min': 'Percentage must be at least 1%.', 'number.max': 'Percentage cannot exceed 100%.' })),
    }),
    expirationDate: Joi.string().allow(null).optional(),
    firstAppointmentOnly: Joi.boolean().default(false),
    oneTime: Joi.boolean().default(false),
}).required();
export var usePromoCodeForm = function () {
    var form = useForm({
        resolver: joiResolver(schema),
        mode: 'onSubmit',
        defaultValues: {
            code: '',
            kind: PROMO_TYPE.amount,
            value: '0.00',
            expirationDate: undefined,
            firstAppointmentOnly: false,
            oneTime: false,
        },
    });
    return form;
};
export var usePromoCodeFormContext = function () {
    var formContext = useFormContext();
    if (!formContext) {
        throw new Error('PromoCodeForm must be wrapped with FormProvider');
    }
    return formContext;
};
